import React, { useEffect, useState } from "react";
import { color } from "../../../resource";
import Text from "../../../components/Text/Text";
import image from "../../../resource/image";
import type { DetailAchieveEntity } from "../../../entities/AchievementEntity";
import { Space } from "antd";
import MilestoneProgress from "../../../components/Progress/MilestoneProgress";
import icon from "../../../resource/icon";
import { formatThaiDate } from "../../../utility/dateHelpers";
import { RightOutlined } from "@ant-design/icons";
import { numberFormatter } from "../../../utility/Formatter";

function PreviewApp({ data }: { data: DetailAchieveEntity | undefined }) {
  const mainRewards = data?.achievementReward?.[0]?.achievementMainReward || [];
  const [firstReward] = data?.achievementReward ?? [];
  const specialRewards = firstReward?.isSpecial ? (firstReward.achievementSpecialReward ?? []) : [];

  const allRewards = [
    ...mainRewards.map((r) => ({
      value: Number(r.targetAmount || 0),
      icon: r.badgeImageUrl ? r.badgeImageUrl : r.badgeMaster?.badgeImageUrl,
      name: r.rewardName,
      targetAmount: r.targetAmount,
      mainImg: r.imageUrl,
    })),
    ...specialRewards.map((r) => ({
      value: Number(r.targetAmount || 0),
      icon: r.badgeImageUrl ? r.badgeImageUrl : r.badgeMaster?.badgeImageUrl,
      name: r.specialRewardName,
      targetAmount: r.targetAmount,
      mainImg: r.imageUrl,
    })),
  ];

  const maxTarget = Math.max(...allRewards.map((r) => r.value));
  const milestonesForProgress = [
    { value: 0, icon: null, name: "", targetAmount: "" },
    ...allRewards.map((r) => ({
      value: (r.value / maxTarget) * 100,
      icon: r.icon,
      name: r.name,
      targetAmount: String(r.targetAmount),
    })),
  ];
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const widthPerMilestone = 90;
  const gap = 8;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalWidth =
    milestonesForProgress.length * widthPerMilestone + (milestonesForProgress.length - 1) * gap;
  const containerWidth = Math.max(totalWidth, windowWidth) / 2.4;
  const checkLength = milestonesForProgress.length - 1 === 1;
  const wordingList = ["รายการที่ได้รับยอดสะสม", "กติกาและเงื่อนไข"];

  return (
    <div
      style={{
        backgroundColor: color.background1,
        borderRadius: 8,
        border: "1px solid #E5EAEE",
        padding: 20,
        overflowY: "auto",
        height: "100%",
        maxHeight: "90vh",
      }}
    >
      <Text fontSize={18} fontWeight={600}>
        ตัวอย่างหน้า Application
      </Text>

      <div
        style={{
          marginTop: 20,
          backgroundColor: color.white,
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            aspectRatio: "5 / 5",
            overflow: "hidden",
          }}
        >
          <img
            src={data?.imageUrl}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
              maskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%)",
              WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%)",
            }}
          />

          <img
            src={image.PhoneStatusBar}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "32px",
              objectFit: "cover",
            }}
          />

          <img
            src={image.CurveBackground}
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              objectFit: "cover",
              pointerEvents: "none",
            }}
          />
        </div>

        <div
          style={{
            backgroundImage: `url(${image.background_tour})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            textAlign: "center",
            padding: "24px 12px",
            color: "#fff",
            height: "200px",
          }}
        >
          <Space wrap size={2} direction='vertical'>
            <Text color='white' fontWeight={600} fontSize={12}>
              ยอดซื้อสะสม
            </Text>
            <Text color='white' fontWeight={600} fontSize={22}>
              ฿ 0.00
            </Text>
          </Space>

          <div
            style={{
              overflowX: checkLength ? "hidden" : "auto",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              padding: "0px 20px 0px 20px",
            }}
            className='no-scrollbar'
          >
            <div
              style={{
                width: checkLength ? "100%" : containerWidth,
                minWidth: checkLength ? "100%" : 120,
              }}
            >
              <MilestoneProgress
                progress={0}
                icon={icon.preview_airplane}
                milestones={milestonesForProgress}
              />
            </div>
          </div>
        </div>
        <Space
          wrap
          size={0}
          direction='vertical'
          style={{ marginTop: "32px", textAlign: "center", padding: 20, display: "flex" }}
        >
          <Text fontFamily='Sarabun' fontSize={12} fontWeight={600}>
            ซื้อครบ&nbsp;
            <Text color='EmeraldGreen' fontFamily='Sarabun' fontSize={14} fontWeight={600}>
              ฿ {numberFormatter(allRewards[0]?.targetAmount || 0, 2)}
            </Text>
          </Text>
          <Text fontFamily='Sarabun' fontSize={12}>
            ปลดล็อค 🔓
            <Text fontFamily='Sarabun' fontSize={12} fontWeight={600}>
              {milestonesForProgress[1]?.name ?? "-"}
            </Text>
          </Text>
          <br />

          <Text fontFamily='Sarabun' fontSize={12} style={{ marginTop: 12 }}>
            {data?.description}
          </Text>
          <Text fontFamily='Sarabun' fontSize={12}>
            รีบสะสมให้ครบภายใน {formatThaiDate(data?.endDate)}
          </Text>
        </Space>

        <div style={{ marginTop: "32px", textAlign: "center", padding: "0 16px" }}>
          <Text fontWeight={700}>รางวัลที่ได้รับ</Text>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "6%",
              marginTop: 16,
            }}
          >
            {allRewards.map((i, key) => (
              <div key={key} style={{ width: 120, textAlign: "center" }}>
                <img
                  src={i.mainImg}
                  style={{
                    width: "100%",
                    aspectRatio: "3 / 4",
                    borderRadius: 8,
                    objectFit: "cover",
                  }}
                />
                <div style={{ marginTop: 4 }}>
                  <Text
                    fontSize={12}
                    fontWeight={700}
                    style={{ display: "block", textAlign: "center" }}
                  >
                    {i.name}
                  </Text>
                  <Text
                    fontSize={12}
                    fontWeight={600}
                    style={{ display: "block", marginTop: 2, textAlign: "center" }}
                  >
                    ฿ {Number(i.targetAmount).toLocaleString()}
                  </Text>
                </div>
              </div>
            ))}
          </div>

          <Space
            wrap
            size={6}
            direction='vertical'
            style={{ width: "100%", margin: "24px 0px 24px 0px" }}
          >
            {wordingList.map((word, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 8,
                  padding: "10px 14px",
                  fontSize: 14,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <span>{word}</span>
                <RightOutlined />
              </div>
            ))}
          </Space>
        </div>
      </div>
    </div>
  );
}

export default PreviewApp;
